import React from 'react';
import { Image, StyleSheet, View } from 'react-native';

import { images } from '../../assets/images';
import { colors } from '../../Styles';
import { HomeProps } from '../containers/HomeContainer';
import { MNOHSButton } from '../MNOHSButton';
import { MNOHSDashboardWrapper } from '../MNOHSDashboardWrapper';

export const HomeScreen: React.FC<HomeProps> = ({ isAuthenticated, isLoading, login }) => {
  return (
    <MNOHSDashboardWrapper
      hasHeader={false}
      padded={true}
      headerTitle={'Home'}
      headerShown={isAuthenticated}
      scrollViewProps={
        isAuthenticated
          ? undefined
          : {
              scrollEnabled: false,
              showsVerticalScrollIndicator: false,
              style: { backgroundColor: colors.white },
            }
      }>
      {!isAuthenticated && (
        <View style={{ height: '100vh' }}>
          <View style={styles.flexedContainer} accessible={true}>
            <Image
              source={images.MNOHSLogo}
              style={styles.logo}
              resizeMode="contain"
              accessibilityLabel="Minnesota Online High School"
            />
          </View>
          <View style={styles.flexedButtonContainer}>
            <MNOHSButton
              title="LOG IN"
              state={isLoading ? 'showingActivityIndicator' : 'enabled'}
              onPress={login}
              accessibilityLabel="Log in"
            />
          </View>
        </View>
      )}
    </MNOHSDashboardWrapper>
  );
};

const styles = StyleSheet.create({
  flexedContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  flexedButtonContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  logo: {
    width: '100%',
    height: '100%',
  },
});
